var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"wrap":"","pa-3":""}},[_c('v-flex',{attrs:{"sm6":"","pl-2":""}},[_c('v-switch',{attrs:{"label":_vm.$t('Pilot.FleetDrawer.FilterOngoing')},model:{value:(_vm.isOnGoingFiltered),callback:function ($$v) {_vm.isOnGoingFiltered=$$v},expression:"isOnGoingFiltered"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }